async function readJsonSafely(res: Response): Promise<unknown | undefined> {
  const text = await res.text();

  if (!text) return undefined;

  try {
    return JSON.parse(text);
  } catch {
    throw new Error('Invalid JSON response from server');
  }
}

function getErrorMessage(data: unknown, fallback: string): string {
  if (data && typeof data === 'object' && 'error' in data && typeof (data as any).error === 'string') {
    return (data as any).error;
  }
  return fallback;
}

export type ForumChatRequestResult = {
  ok: boolean;
  queued?: boolean;
  alreadyRequested?: boolean;
  chatable?: boolean;
  reason?: string;
};

export async function requestForumChat(targetUsername: string): Promise<ForumChatRequestResult> {
  const res = await fetch('/api/discourse/chat/request', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ targetUsername }),
  });

  const data = await readJsonSafely(res) as ForumChatRequestResult | undefined;

  if (!res.ok) {
    throw new Error(getErrorMessage(data, 'Failed to request chat'));
  }

  return {
    ok: true,
    queued: Boolean(data?.queued),
    alreadyRequested: Boolean(data?.alreadyRequested),
    chatable: Boolean(data?.chatable),
    reason: data?.reason,
  };
}
